import React from "react";

function Dashboard(){
    return <h1>Dashboard component</h1>;
};

export default Dashboard;
